import React, { Component } from 'react'
import Select from 'react-select'
import { AppContext } from "@lightspeed-invoicing/core-client/frontend";
import { injectIntl } from "react-intl";


class PaymentTermSelect extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            selectedOption: this.props.value || '',
            disabled: this.props.disabled || false,
            multi: this.props.multi || false,
        }

        const defaultCallback = () => { }
        this.name = this.props.name
        this.placeholder = this.props.placeholder
        this.onChange = this.props.onChange || defaultCallback
        this.handleChange = this.handleChange.bind(this)
    }

    componentDidMount() {
        AppContext.getApiClient().get('/payment-terms').then(r => {
            let data = []
            data = data.concat(r.data ? r.data.map(t => {
                return {
                    value: t.id,
                    label: t.attributes.name
                }
            }) : [])
            
            this.setState({
                options: data
            })
        })
    }


    handleChange(selectedOption) {
        this.setState({
            selectedOption: selectedOption
        }, () => {
            if (selectedOption) {
                if (this.state.multi === true) {
                    this.onChange(selectedOption.map(option => { return option.value }), selectedOption.map(option => { return option.label }).join(','))
                } else {
                    this.onChange(selectedOption.value, selectedOption.label)
                }
            } else {
                this.onChange("", "")
            }
        });
    }


    componentWillReceiveProps(nextProps) {
        if (nextProps.value !== this.state.selectedOption) {
            this.setState({
                selectedOption: nextProps.value || '',
                disabled: nextProps.disabled || false,
            })
        }
    }

    render() {
        return (
            <Select
                searchable={this.props.searchable || false}
                disabled={this.state.disabled}
                name={this.name}
                multi={this.state.multi}
                placeholder={this.placeholder}
                value={this.state.selectedOption}
                onChange={this.handleChange}
                options={this.state.options}
                clearable={this.props.clearable || false}
            />
        )
    }
}

export default injectIntl(PaymentTermSelect)





// WEBPACK FOOTER //
// ./src/payment-term/locationselect.component.jsx